import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isAdminUser } from "../../utils/userUtils";

import api from "../../axiosconfig.js";
import { MainHeader } from "../chatMain/MainHeader/MainHeader.jsx";
import backgound from "../../assets/Home-backgroud.png";
import Profile1 from "../../assets/Profile1.png";
import Profile2 from "../../assets/Profile2.png";
import Profile3 from "../../assets/Profile.svg";
import Profile4 from "../../assets/Profile3.png";

import { HomeQuestions } from "./HomeQuestions.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartPie, faClipboard, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import UserStat from "./components/stat/user-stat.jsx";
import PersonalEngagementOverview from "./components/stat/personal-engagement.jsx";
import DomainEngagementOverview from "./components/stat/pearli-focus.jsx";
import AssessmentHistory from "./components/assessmnet/history.jsx";
import WellnessCheckinSection from "../../components/checkins/WellnessCheckinSection";

import "./HomeMaincontent.css";

// Utils
const getText = async (setName) => {
  try {
    const responseName = await api.post("/dataRequest", { request: "getUserName" });
    setName(responseName.data.name);
  } catch {
    setName("");
  }
};

export const HomeMaincontent = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const isAdmin = isAdminUser(user);

  // Header/user
  const [name, setName] = useState("");

  // Tabs
  const [homeTabMode, setHomeTabMode] = useState(2); // 1 = Check-ins (nav), 2 = Your personal stats, 3 = Assessment history, 4 = Take a tour (nav)

  // Role / Name on load
  useEffect(() => {
    if (!user) return;
    getText(setName);
  }, [user]);

  // Tabs
  const changeTabMode = (mode) => {
    if (mode === 1) { navigate("/home"); return; }
    if (mode === 4) { navigate("/tour"); return; }
    setHomeTabMode(mode);
  };

  return (
    <div className="HomemainContent">
      <div className="header-home">
        {/* <MainHeader
          page={"profile"}
          titleText={`Welcome to Mindsherpa${name ? `, ${name}` : ""}`}
          subtitleText={"Reflecting on Loving-Kindness 💗"}
        />  */}
      </div>

      <div className="main-frame">
        {/* Top hero + questions */}
        {/* <div className="well-being-guide" style={{ display: homeTabMode === 1 || homeTabMode === 2 ? "flex" : "none" }}>
          <div className="backgound-home">
            <img src={backgound} alt="" className="backgound-image" />
            <div className="text-image">
              <div>
                <h1>Welcome to your daily well-being journey! Get started</h1>
              </div>

              <div className="icon-button-group">
                <svg
                  className="mainhome-arrow-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#clip0_2610_8867)">
                    <path d="M5 16H27" stroke="#F1F5F9" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                      d="M18 7L27 16L18 25"
                      stroke="#F1F5F9"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2610_8867">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <button className="tour-button dashboard-register-button" onClick={() => navigate("/tour")}>
                  {isAdmin ? "Mindsherpa Administrator Tour" : "Mindsherpa Tour"}
                </button>
              </div>
            </div>
          </div>

          <div className="homepage-questions" id="questions">
            <HomeQuestions mode="mood" />
          </div>
        </div>

        {/* Tabs */}
        <div className="home-tab-container">
          <div className={`home-tab ${homeTabMode === 1 ? "active" : ""}`} onClick={() => changeTabMode(1)}>
            <div className="home-tab-icon">
              <FontAwesomeIcon icon={faClipboard} />
            </div>
            <div className="home-tab-text">Check-ins</div>
          </div>

          <div className={`home-tab ${homeTabMode === 2 ? "active" : ""}`} onClick={() => changeTabMode(2)}>
            <div className="home-tab-icon">
              <FontAwesomeIcon icon={faChartPie} />
            </div>
            <div className="home-tab-text">Your personal stats</div>
          </div>

          <div className={`home-tab ${homeTabMode === 3 ? "active" : ""}`} onClick={() => changeTabMode(3)}>
            <div className="home-tab-icon">
              <FontAwesomeIcon icon={faClipboard} />
            </div>
            <div className="home-tab-text">Assessment history</div>
          </div>

          <div className={`home-tab ${homeTabMode === 4 ? "active" : ""}`} onClick={() => changeTabMode(4)}>
            <div className="home-tab-icon">
              <FontAwesomeIcon icon={faInfoCircle} />
            </div>
            <div className="home-tab-text">Take a tour</div>
          </div>
        </div>

        {/* Main / Statistics */}
        <div className="home-main-section" style={{ display: homeTabMode === 2 ? "block" : "none" }}></div>

        <div className="home-statistics-section" style={{ display: homeTabMode === 2 ? "flex" : "none" }}>
          {/* Mobile message */}
          <div className="home-statistics-group-container-mobile">
            <div className="home-statistics-section-text-container-mobile">
              <div className="home-statistics-section-title">Statistics Unavailable on Mobile</div>
              <div className="home-statistics-section-subtitle">
                We're sorry, but the Statistics page is currently not supported on mobile devices. For the best
                experience and full functionality, please access this page from a desktop or laptop computer. We're
                working on making this feature mobile-friendly and appreciate your patience!
              </div>
            </div>
          </div>

          {/* User Login */}
          <UserStat />

          {/* Well-Being Metrics */}
          <WellnessCheckinSection />

          {/* Engagement + PEARLI Overview are split components */}
          <PersonalEngagementOverview />
          <DomainEngagementOverview />
        </div>

        {/* Assessment History (split component) */}
        <AssessmentHistory homeTabMode={homeTabMode} />

        {/* Footer */}
        <div className="footer">
          <p className="footer-text">72% of users feel less stressed after using the mindfulness</p>
          <div className="profile-footer">
            <div className="calender-clock">
              <div className="people">
                <img src={Profile1} alt="" className="people-img" />
                <img src={Profile2} alt="" className="people-img" />
                <img src={Profile3} alt="" className="people-img" />
                <img src={Profile4} alt="" className="people-img" />
                <p>+218</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
